import React, { useEffect, useState } from "react";
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { UserItem } from "../UserItem";

const userController = new User();

export function ListUsers(props) {
  const { usersActive, reload, onReload } = props;
  const [users, setUsers] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setUsers(null);
        const response = await userController.getUsers(usersActive);
        setUsers(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [usersActive, reload, accessToken]);

  if (!users) return <Loader active inline="centered" />;
  if (size(users) === 0) return "No hay ningún usuario";

  return map(users, (user) => (
    <UserItem key={user.id} user={user} onReload={onReload} />
  ));
}
